const namespace = 'bravissimo/request-magazine';

export const REQUEST_FAILED = `${namespace}/REQUEST_FAILED`;
export const MAGAZINE_REQUESTED = `${namespace}/MAGAZINE_REQUESTED`;
export const REQUEST_SUCCEEDED = `${namespace}/REQUEST_SUCCEEDED`;
export const CLOSE_MESSAGES = `${namespace}/CLOSE_MESSAGES`;
